import { forwardRef } from "react"
import { Label, Textarea } from "@ui/shad"
import { cn } from "@ui/utils"

interface TextareaInputProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string
  label?: string
  error?: boolean
  helperText?: string
}

export const TextareaInput = forwardRef<HTMLTextAreaElement, TextareaInputProps>(
  ({ label, error, id, helperText, ...props }, ref) => {
    return (
      <div className="space-y-1">
        {label && (
          <Label htmlFor={id} className={cn(error && "text-destructive")}>
            {label}
          </Label>
        )}
        <Textarea ref={ref} id={id} {...props} />
        {helperText && <p className="text-muted-foreground text-xs">{helperText}</p>}
      </div>
    )
  }
)

TextareaInput.displayName = "TextareaInput"
